(function () {
  const root = document.querySelector('[data-barnacle-customizer]');
  if (!root) return;

  const CUP_COLORS = {
    white: '#ffffff',
    black: '#1a1a1a',
    pink: '#ec4899'
  };

  const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
  const ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml'];

  const FONT_SIZE_MAP = {
    main: { medium: 42, large: 54 },
    subtitle: { medium: 20, large: 26 }
  };

  // ringFill state shape:
  //   null                                            (no fill, gray fallback)
  //   { source: 'color',  hex: '#xxxxxx', name: '...' }
  //   { source: 'upload', name: '...', url: '...', file: File }
  //   { source: 'preset', name: '...', url: '...' }
  //
  // PRESET source is special: the PNG is a FULLY composed Barnacle design.
  // The print file uses the preset image directly + customer text overlay only.
  // The brand mark is already in the preset image, so we hide the SVG brand
  // mark when a preset is selected.
  const state = {
    cupColor: 'white',
    cupVariantId: null,
    cupPrice: null,
    ringFill: null,
    textMain: '',
    textSubtitle: '',
    textFont: "'Anton', sans-serif",
    textFontName: 'Anton',
    textGoogleFont: 'Anton',
    textColor: '#1a1a1a',
    textSize: 'medium',
    comments: ''
  };

  // DOM refs
  const cupRadios = root.querySelectorAll('[data-cup-selector] input[type="radio"]');
  const cupFill = root.querySelector('[data-cup-fill]');
  const cupOverlay = root.querySelector('[data-preview-cup-overlay]');
  const cupOverlayFill = root.querySelector('[data-cup-overlay-fill]');
  const ringFill = root.querySelector('[data-ring-fill]');
  const previewSvg = root.querySelector('[data-preview-svg]');
  const ctaPrice = root.querySelector('[data-cta-price]');
  const brandGroup = root.querySelector('[data-preview-brand]');

  // Text refs (preview)
  const textMainElement = root.querySelector('[data-text-main-element]');
  const textMainPath = root.querySelector('[data-text-main-path]');
  const textSubtitleElement = root.querySelector('[data-text-subtitle-element]');
  const textSubtitlePath = root.querySelector('[data-text-subtitle-path]');

  // Text refs (controls)
  const textMainInput = root.querySelector('[data-text-main-input]');
  const textMainCount = root.querySelector('[data-text-main-count]');
  const textSubtitleInput = root.querySelector('[data-text-subtitle-input]');
  const textSubtitleCount = root.querySelector('[data-text-subtitle-count]');
  const fontOptions = root.querySelectorAll('[data-font-option]');
  const sizeOptions = root.querySelectorAll('[data-text-size]');
  const colorInput = root.querySelector('[data-text-color-input]');
  const colorPreview = root.querySelector('[data-text-color-preview]');

  // Comments refs (Step 4)
  const commentsInput = root.querySelector('[data-comments-input]');
  const commentsCount = root.querySelector('[data-comments-count]');

  // Ring color refs
  const colorSwatches = root.querySelectorAll('[data-color-swatch]');
  const ringColorCustom = root.querySelector('[data-ring-color-custom]');
  const ringColorCustomPreview = root.querySelector('[data-ring-color-custom-preview]');
  const ringColorApply = root.querySelector('[data-ring-color-apply]');

  // Upload + preset refs
  const fileInput = root.querySelector('[data-file-input]');
  const uploadArea = root.querySelector('[data-upload-area]');
  const uploadFilename = root.querySelector('[data-upload-filename]');
  const uploadClear = root.querySelector('[data-upload-clear]');
  const presetButtons = root.querySelectorAll('[data-preset]');

  // Tab refs
  const tabButtons = root.querySelectorAll('[data-tab]');
  const tabPanels = root.querySelectorAll('[data-tab-panel]');

  // Init cup state
  const initialRadio = root.querySelector('[data-cup-selector] input[type="radio"]:checked');
  if (initialRadio) {
    state.cupColor = initialRadio.value;
    state.cupVariantId = initialRadio.dataset.variantId;
    state.cupPrice = initialRadio.dataset.variantPrice;
  }

  // Init font state
  const initialFont = root.querySelector('[data-font-option].is-active');
  if (initialFont) {
    state.textFont = initialFont.dataset.fontFamily;
    state.textFontName = initialFont.dataset.fontName;
    state.textGoogleFont = initialFont.dataset.fontGoogle;
  }

  // Google Fonts loader
  const loadedFonts = new Set();
  function loadGoogleFont(googleFontName) {
    if (!googleFontName || loadedFonts.has(googleFontName)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' + encodeURIComponent(googleFontName).replace(/%20/g, '+') + ':wght@400;700&display=swap';
    document.head.appendChild(link);
    loadedFonts.add(googleFontName);
  }

  // Pattern (image) application for SVG preview
  function applyRingPattern(imageUrl) {
    if (!previewSvg || !ringFill) return;
    let defs = previewSvg.querySelector('defs');
    if (!defs) return;

    const PATTERN_ID = 'barnacle-ring-pattern';
    let pattern = defs.querySelector('#' + PATTERN_ID);

    if (!pattern) {
      pattern = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
      pattern.setAttribute('id', PATTERN_ID);
      pattern.setAttribute('patternUnits', 'userSpaceOnUse');
      pattern.setAttribute('x', '0');
      pattern.setAttribute('y', '0');
      pattern.setAttribute('width', '613');
      pattern.setAttribute('height', '613');

      const image = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      image.setAttribute('x', '0');
      image.setAttribute('y', '0');
      image.setAttribute('width', '613');
      image.setAttribute('height', '613');
      image.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      image.setAttribute('data-pattern-image', '');
      pattern.appendChild(image);
      defs.appendChild(pattern);
    }

    const image = pattern.querySelector('[data-pattern-image]');
    if (image) {
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageUrl);
      image.setAttribute('href', imageUrl);
    }

    ringFill.setAttribute('fill', 'url(#' + PATTERN_ID + ')');
  }

  // Apply preset PNG directly to the preview (full image, no clipping, since the
  // preset PNG is already a finished design with the ring shape baked in)
  // The client now provides preset PNGs with the artwork ring filling the
  // file edge-to-edge (~98%). So we render them at the canvas size 1:1, no
  // scale-up needed. Earlier files had ~63% fill and required a 1.59x
  // upscale; that workaround has been removed since the source files were
  // re-exported correctly.
  const PREVIEW_CANVAS = 613;

  function applyPresetImage(imageUrl) {
    if (!previewSvg) return;
    let presetLayer = previewSvg.querySelector('[data-preset-layer]');

    if (!presetLayer) {
      presetLayer = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      presetLayer.setAttribute('data-preset-layer', '');
      presetLayer.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      // Insert just after the ring artwork group, before the brand/text groups
      const artworkGroup = previewSvg.querySelector('[data-preview-artwork]');
      if (artworkGroup && artworkGroup.parentNode) {
        artworkGroup.parentNode.insertBefore(presetLayer, artworkGroup.nextSibling);
      } else {
        previewSvg.appendChild(presetLayer);
      }
    }

    // Always (re)apply sizing/positioning in case the layer was created earlier
    // with old dimensions.
    presetLayer.setAttribute('x', '0');
    presetLayer.setAttribute('y', '0');
    presetLayer.setAttribute('width', String(PREVIEW_CANVAS));
    presetLayer.setAttribute('height', String(PREVIEW_CANVAS));
    presetLayer.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageUrl);
    presetLayer.setAttribute('href', imageUrl);
    presetLayer.style.display = 'block';
  }

  function hidePresetImage() {
    if (!previewSvg) return;
    const presetLayer = previewSvg.querySelector('[data-preset-layer]');
    if (presetLayer) presetLayer.style.display = 'none';
  }

  // Remove any existing pattern (used when switching to solid color)
  function removeRingPattern() {
    if (!previewSvg) return;
    const defs = previewSvg.querySelector('defs');
    if (!defs) return;
    const pattern = defs.querySelector('#barnacle-ring-pattern');
    if (pattern) pattern.remove();
  }

  // Apply solid color fill
  function applyRingColor(hex) {
    if (!ringFill) return;
    removeRingPattern();
    ringFill.setAttribute('fill', hex);
  }

  function render() {
    // Cup
    const cupHex = CUP_COLORS[state.cupColor] || '#ffffff';
    if (cupFill) cupFill.setAttribute('fill', cupHex);
    // Also apply the cup color to the overlay, which renders ON TOP of the
    // preset image so the customer can see their cup selection in preset mode.
    if (cupOverlayFill) cupOverlayFill.setAttribute('fill', cupHex);

    // Branch by ring fill source
    const isPreset = state.ringFill && state.ringFill.source === 'preset';

    // Cup overlay is only needed when a preset is active (otherwise the
    // underlying cup element is already visible).
    if (cupOverlay) {
      cupOverlay.style.display = isPreset ? '' : 'none';
    }

    if (isPreset) {
      // Preset: show the full preset PNG, hide our own brand mark and ring fill.
      // The preset PNG has the brand mark baked in already.
      applyPresetImage(state.ringFill.url);
      removeRingPattern();
      if (ringFill) ringFill.setAttribute('fill', 'transparent');
      // Hide the SVG brand mark with three independent mechanisms so it cannot
      // leak through any caching, CSS specificity, or attribute reset.
      if (brandGroup) {
        brandGroup.style.display = 'none';
        brandGroup.setAttribute('visibility', 'hidden');
        brandGroup.classList.add('is-hidden-preset');
      }
    } else {
      // Color or upload or nothing: hide preset layer, show our own composition.
      hidePresetImage();
      if (state.ringFill) {
        if (state.ringFill.source === 'color') {
          applyRingColor(state.ringFill.hex);
        } else if (state.ringFill.url) {
          applyRingPattern(state.ringFill.url);
        }
      } else {
        removeRingPattern();
        if (ringFill) ringFill.setAttribute('fill', '#d0d0d0');
      }
      // Restore brand mark visibility, undoing all three hide mechanisms.
      if (brandGroup) {
        brandGroup.style.display = '';
        brandGroup.setAttribute('visibility', 'visible');
        brandGroup.classList.remove('is-hidden-preset');
      }
    }

    // With the preset image scaled to fill the canvas (matching color/upload),
    // the text uses the same wider arcs and font sizes regardless of fill source.
    const mainArcHref = '#barnacle-arc-bottom-main';
    const subtitleArcHref = '#barnacle-arc-bottom-subtitle';
    const PREVIEW_FONT_SIZES = {
      main: FONT_SIZE_MAP.main[state.textSize] || 42,
      subtitle: FONT_SIZE_MAP.subtitle[state.textSize] || 20
    };

    // Main text
    if (textMainPath) {
      textMainPath.textContent = (state.textMain || '').toUpperCase();
      // Swap the arc reference if needed (handles state from older code)
      const currentHref = textMainPath.getAttribute('href') || textMainPath.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (currentHref !== mainArcHref) {
        textMainPath.setAttribute('href', mainArcHref);
        textMainPath.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', mainArcHref);
      }
    }
    if (textMainElement) {
      textMainElement.setAttribute('fill', state.textColor);
      textMainElement.style.fontFamily = state.textFont;
      textMainElement.setAttribute('font-size', PREVIEW_FONT_SIZES.main);
    }

    // Subtitle text
    if (textSubtitlePath) {
      textSubtitlePath.textContent = (state.textSubtitle || '').toUpperCase();
      const currentHref = textSubtitlePath.getAttribute('href') || textSubtitlePath.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
      if (currentHref !== subtitleArcHref) {
        textSubtitlePath.setAttribute('href', subtitleArcHref);
        textSubtitlePath.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', subtitleArcHref);
      }
    }
    if (textSubtitleElement) {
      textSubtitleElement.setAttribute('fill', state.textColor);
      textSubtitleElement.style.fontFamily = state.textFont;
      textSubtitleElement.setAttribute('font-size', PREVIEW_FONT_SIZES.subtitle);
    }

    // CTA price
    if (ctaPrice && state.cupPrice) {
      ctaPrice.textContent = state.cupPrice;
    }

    // Preset active state
    presetButtons.forEach(function (btn) {
      const isActive = state.ringFill
        && state.ringFill.source === 'preset'
        && state.ringFill.name === btn.dataset.presetName;
      btn.classList.toggle('is-active', !!isActive);
    });

    // Color swatch active state
    colorSwatches.forEach(function (btn) {
      const isActive = state.ringFill
        && state.ringFill.source === 'color'
        && state.ringFill.hex
        && state.ringFill.hex.toLowerCase() === (btn.dataset.colorHex || '').toLowerCase()
        && state.ringFill.name === btn.dataset.colorName;
      btn.classList.toggle('is-active', !!isActive);
    });

    // Upload state
    if (uploadArea) {
      const isUpload = state.ringFill && state.ringFill.source === 'upload';
      uploadArea.classList.toggle('is-uploaded', !!isUpload);
      if (uploadClear) uploadClear.hidden = !isUpload;
      if (uploadFilename) {
        uploadFilename.textContent = isUpload
          ? state.ringFill.name
          : 'Click to upload your image';
      }
    }

    // Text color preview hex
    if (colorPreview) {
      colorPreview.textContent = state.textColor.toUpperCase();
    }

    // Custom ring color preview hex
    if (ringColorCustomPreview && ringColorCustom) {
      ringColorCustomPreview.textContent = ringColorCustom.value.toUpperCase();
    }

    // Character counts
    if (textMainCount && textMainInput) {
      textMainCount.textContent = textMainInput.value.length + ' / ' + textMainInput.maxLength;
    }
    if (textSubtitleCount && textSubtitleInput) {
      textSubtitleCount.textContent = textSubtitleInput.value.length + ' / ' + textSubtitleInput.maxLength;
    }
  }

  // Cup radio change
  cupRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (this.checked) {
        state.cupColor = this.value;
        state.cupVariantId = this.dataset.variantId;
        state.cupPrice = this.dataset.variantPrice;
        render();
      }
    });
  });

  // Tab switching
  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const tabId = btn.dataset.tab;
      tabButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      tabPanels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.tabPanel === tabId);
      });
    });
  });

  // Color swatch clicks
  colorSwatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const hex = btn.dataset.colorHex || '#cccccc';
      const name = btn.dataset.colorName || 'Color';
      if (fileInput) fileInput.value = '';
      state.ringFill = { source: 'color', hex: hex, name: name };
      render();
    });
  });

  // Custom ring color picker (live update on input)
  if (ringColorCustom) {
    ringColorCustom.addEventListener('input', function () {
      if (ringColorCustomPreview) {
        ringColorCustomPreview.textContent = this.value.toUpperCase();
      }
    });
  }

  // Custom ring color apply button
  if (ringColorApply && ringColorCustom) {
    ringColorApply.addEventListener('click', function () {
      const hex = ringColorCustom.value;
      if (fileInput) fileInput.value = '';
      state.ringFill = { source: 'color', hex: hex, name: 'Custom (' + hex.toUpperCase() + ')' };
      render();
    });
  }

  // File upload
  if (fileInput) {
    fileInput.addEventListener('change', function (e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;

      if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
        alert('Please upload a JPG, PNG, or SVG file.');
        fileInput.value = '';
        return;
      }

      if (file.size > MAX_UPLOAD_BYTES) {
        alert('File is too large. Maximum size is 20MB.');
        fileInput.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = function (ev) {
        state.ringFill = {
          source: 'upload',
          name: file.name,
          url: ev.target.result,
          file: file
        };
        render();
      };
      reader.onerror = function () {
        alert('Could not read the file. Please try again.');
      };
      reader.readAsDataURL(file);
    });
  }

  // Clear upload
  if (uploadClear) {
    uploadClear.addEventListener('click', function () {
      state.ringFill = null;
      if (fileInput) fileInput.value = '';
      render();
    });
  }

  // Preset clicks
  presetButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const name = btn.dataset.presetName;
      const url = btn.dataset.presetImage;
      if (!url) return;
      if (fileInput) fileInput.value = '';
      state.ringFill = { source: 'preset', name: name, url: url };
      render();
    });
  });

  // Text main input
  if (textMainInput) {
    textMainInput.addEventListener('input', function () {
      state.textMain = this.value;
      render();
    });
  }

  // Text subtitle input
  if (textSubtitleInput) {
    textSubtitleInput.addEventListener('input', function () {
      state.textSubtitle = this.value;
      render();
    });
  }

  // Comments input (Step 4) — captures the customer's optional note. We do
  // NOT call render() here because the comment doesn't change the visual
  // preview; we only update the character counter and store the value to
  // submit as a line item property at cart time.
  if (commentsInput) {
    commentsInput.addEventListener('input', function () {
      state.comments = this.value;
      if (commentsCount) {
        commentsCount.textContent = this.value.length + ' / ' + this.maxLength;
      }
    });
  }

  // Font selection
  fontOptions.forEach(function (btn) {
    btn.addEventListener('click', function () {
      fontOptions.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.textFont = btn.dataset.fontFamily;
      state.textFontName = btn.dataset.fontName;
      state.textGoogleFont = btn.dataset.fontGoogle;
      loadGoogleFont(state.textGoogleFont);
      render();
    });
  });

  // Size toggle
  sizeOptions.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeOptions.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.textSize = btn.dataset.textSize;
      render();
    });
  });

  // Text color picker
  if (colorInput) {
    colorInput.addEventListener('input', function () {
      state.textColor = this.value;
      render();
    });
  }

  // Pre-load all fonts
  fontOptions.forEach(function (btn) {
    loadGoogleFont(btn.dataset.fontGoogle);
  });

  // Initial render
  render();

  // Re-render after fonts load
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      render();
    });
  } else {
    setTimeout(render, 500);
  }

  // ===========================================
  // PRINT FILE GENERATION (with branching by source)
  // ===========================================

  const PRINT_SIZE = 1839;
  const PRINT_OUTER_RADIUS = 1839 / 2;
  const PRINT_INNER_RADIUS = 1125 / 2;
  const PRINT_CENTER = PRINT_SIZE / 2;
  const PRINT_SCALE = PRINT_SIZE / 613;

  function generatePrintFile() {
    return new Promise(function (resolve, reject) {
      const canvas = document.createElement('canvas');
      canvas.width = PRINT_SIZE;
      canvas.height = PRINT_SIZE;
      const ctx = canvas.getContext('2d');

      const isPreset = state.ringFill && state.ringFill.source === 'preset';

      function finalizeWithText() {
        // Draw customer text on top of whatever was drawn
        drawText().then(function () {
          canvas.toBlob(function (blob) {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Canvas toBlob failed'));
            }
          }, 'image/png');
        });
      }

      if (isPreset) {
        // PRESET PATH: Use the finished design PNG directly.
        // No ring clipping, no brand mark drawing, no color fill.
        // Just draw the preset image at full canvas size, then overlay customer text.
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          // Preset PNGs may not be square (his sample images are taller than wide
          // because of the brand mark extending above the ring). We need to draw
          // the image preserving its aspect, but the OUTPUT print file must be
          // 1839x1839 (the printable area).
          // Preset PNGs now fill their file edge-to-edge, so we render them
          // at canvas size 1:1. No scale-up needed.
          ctx.drawImage(img, 0, 0, PRINT_SIZE, PRINT_SIZE);
          finalizeWithText();
        };
        img.onerror = function () {
          console.error('Preset image failed to load');
          // Fall back to gray fill so customer text still gets through
          ctx.fillStyle = '#d0d0d0';
          ctx.fillRect(0, 0, PRINT_SIZE, PRINT_SIZE);
          finalizeWithText();
        };
        img.src = state.ringFill.url;
      } else {
        // COLOR/UPLOAD PATH: build the ring shape, fill it, draw text.
        ctx.save();
        ctx.beginPath();
        ctx.arc(PRINT_CENTER, PRINT_CENTER, PRINT_OUTER_RADIUS, 0, Math.PI * 2, false);
        ctx.arc(PRINT_CENTER, PRINT_CENTER, PRINT_INNER_RADIUS, 0, Math.PI * 2, true);
        ctx.clip('evenodd');

        if (state.ringFill && state.ringFill.source === 'color') {
          ctx.fillStyle = state.ringFill.hex;
          ctx.fillRect(0, 0, PRINT_SIZE, PRINT_SIZE);
          ctx.restore();
          finalizeWithText();
        } else if (state.ringFill && state.ringFill.url) {
          // Upload path
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            ctx.drawImage(img, 0, 0, PRINT_SIZE, PRINT_SIZE);
            ctx.restore();
            finalizeWithText();
          };
          img.onerror = function () {
            console.warn('Upload image failed to load, using fallback');
            ctx.fillStyle = '#d0d0d0';
            ctx.fillRect(0, 0, PRINT_SIZE, PRINT_SIZE);
            ctx.restore();
            finalizeWithText();
          };
          img.src = state.ringFill.url;
        } else {
          ctx.restore();
          finalizeWithText();
        }
      }

      function drawText() {
        return new Promise(function (textResolve) {
          // Wait for fonts then draw curved text
          const fontSize = (FONT_SIZE_MAP.main[state.textSize] || 42) * PRINT_SCALE;
          const fontReady = document.fonts && document.fonts.load
            ? document.fonts.load(fontSize + 'px ' + state.textFont)
            : Promise.resolve();

          fontReady.then(function () {
            renderText();
            textResolve();
          }).catch(function () {
            renderText();
            textResolve();
          });
        });
      }

      function renderText() {
        // Main text sits closer to the cup (radius 235) so it appears ABOVE
        // the subtitle on the bottom of the ring. Subtitle sits closer to the
        // outer edge (radius 280) so it appears BELOW the main text. When
        // only one of the two is present, the single line is centered at 245.
        // Radii were nudged outward from 225/270 to give the main text more
        // clearance from the cup hole edge.
        const hasMain = !!state.textMain;
        const hasSubtitle = !!state.textSubtitle;
        let mainRadius, subtitleRadius;

        if (hasMain && hasSubtitle) {
          mainRadius = 245 * PRINT_SCALE;
          subtitleRadius = 285 * PRINT_SCALE;
        } else {
          mainRadius = 245 * PRINT_SCALE;
          subtitleRadius = 245 * PRINT_SCALE;
        }

        if (hasMain) {
          drawCurvedText({
            text: state.textMain.toUpperCase(),
            radius: mainRadius,
            fontSize: (FONT_SIZE_MAP.main[state.textSize] || 42) * PRINT_SCALE,
            font: state.textFont,
            color: state.textColor
          });
        }

        if (hasSubtitle) {
          drawCurvedText({
            text: state.textSubtitle.toUpperCase(),
            radius: subtitleRadius,
            fontSize: (FONT_SIZE_MAP.subtitle[state.textSize] || 20) * PRINT_SCALE,
            font: state.textFont,
            color: state.textColor
          });
        }
      }

      function drawCurvedText(opts) {
        const text = opts.text;
        const radius = opts.radius;
        const fontSize = opts.fontSize;

        ctx.save();
        ctx.font = '400 ' + fontSize + 'px ' + opts.font;
        ctx.fillStyle = opts.color;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';

        const chars = text.split('');
        const charWidths = chars.map(function (c) { return ctx.measureText(c).width; });
        const totalWidth = charWidths.reduce(function (a, b) { return a + b; }, 0);
        const totalAngle = totalWidth / radius;
        const startAngle = Math.PI / 2 + totalAngle / 2;
        let currentAngle = startAngle;

        for (let i = 0; i < chars.length; i++) {
          const charWidth = charWidths[i];
          currentAngle -= (charWidth / 2) / radius;

          const x = PRINT_CENTER + radius * Math.cos(currentAngle);
          const y = PRINT_CENTER + radius * Math.sin(currentAngle);

          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(currentAngle - Math.PI / 2);
          ctx.fillText(chars[i], 0, 0);
          ctx.restore();

          currentAngle -= (charWidth / 2) / radius;
        }

        ctx.restore();
      }
    });
  }

  // ===========================================
  // CART INTEGRATION
  // ===========================================

  function makeOrderRef() {
    const t = Date.now().toString(36);
    const r = Math.random().toString(36).slice(2, 6);
    return t + '-' + r;
  }

  function buildPrintFilename(ref) {
    const parts = ['barnacle', state.cupColor, ref];
    return parts.join('-').replace(/[^a-z0-9\-]/gi, '').toLowerCase() + '.png';
  }

  function describeRingFill() {
    if (!state.ringFill) return 'Plain (no pattern)';
    if (state.ringFill.source === 'color') {
      return 'Color: ' + state.ringFill.name + ' (' + state.ringFill.hex.toUpperCase() + ')';
    }
    if (state.ringFill.source === 'preset') {
      return 'Preset: ' + state.ringFill.name;
    }
    if (state.ringFill.source === 'upload') {
      return 'Uploaded: ' + state.ringFill.name;
    }
    return 'Unknown';
  }

  function validate() {
    const errors = [];
    if (!state.cupVariantId) {
      errors.push('Please choose a center cup color.');
    }
    return errors;
  }

  function setCtaState(label, disabled) {
    if (!ctaButton) return;
    ctaButton.disabled = !!disabled;
    if (label !== null && label !== undefined) {
      ctaButton.innerHTML = label;
    }
  }

  function submitToCart() {
    return new Promise(function (resolve, reject) {
      const orderRef = makeOrderRef();

      setCtaState('Generating your design...', true);

      generatePrintFile().then(function (printBlob) {
        setCtaState('Adding to cart...', true);

        const formData = new FormData();

        formData.append('id', state.cupVariantId);
        formData.append('quantity', '1');

        formData.append('properties[Center Cup]', state.cupColor.charAt(0).toUpperCase() + state.cupColor.slice(1));
        formData.append('properties[Ring Design]', describeRingFill());

        if (state.textMain) {
          formData.append('properties[Main Text]', state.textMain);
        }
        if (state.textSubtitle) {
          formData.append('properties[Subtitle]', state.textSubtitle);
        }
        if (state.textMain || state.textSubtitle) {
          formData.append('properties[Font]', state.textFontName);
          formData.append('properties[Text Color]', state.textColor.toUpperCase());
          formData.append('properties[Text Size]', state.textSize.charAt(0).toUpperCase() + state.textSize.slice(1));
        }

        // Optional customer comments (Step 4). Only attached if the customer
        // typed something, to keep cart properties tidy.
        if (state.comments && state.comments.trim().length > 0) {
          formData.append('properties[Comments]', state.comments.trim());
        }

        formData.append('properties[_Order Ref]', orderRef);

        const printFilename = buildPrintFilename(orderRef);
        const printFile = new File([printBlob], printFilename, { type: 'image/png' });
        formData.append('properties[_Print File]', printFile);

        if (state.ringFill && state.ringFill.source === 'upload' && state.ringFill.file) {
          formData.append('properties[_Original Upload]', state.ringFill.file);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || err.message || 'Could not add to cart.');
            });
          }
          return response.json();
        })
        .then(function (cartItem) {
          console.log('Added to cart', cartItem);
          resolve(cartItem);
        })
        .catch(reject);
      })
      .catch(reject);
    });
  }

  const ctaButton = root.querySelector('[data-add-to-cart]');
  if (ctaButton) {
    ctaButton.addEventListener('click', function () {
      const originalLabel = ctaButton.innerHTML;

      const errors = validate();
      if (errors.length) {
        alert(errors.join('\n'));
        return;
      }

      submitToCart()
        .then(function () {
          setCtaState('Added! Redirecting...', true);
          setTimeout(function () {
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          alert('Could not add to cart. ' + (err.message || 'Please try again.'));
          setCtaState(originalLabel, false);
        });
    });
  }

  // Expose for debugging
  root._barnacleState = state;
  root._barnacleRender = render;
  root._barnaclePrint = generatePrintFile;
  root._barnacleSubmit = submitToCart;

  console.log('Barnacle customizer ready (with preset PNG support)', state);
})();
